// Pixel-art sprites. Each sprite is a list of equal-length rows; each character
// maps to a PALETTE color and '.' is transparent. See pixels.js for rendering.

export const PALETTE = {
  // Davie
  K: '#17161b', // hair
  k: '#34323d', // hair highlight
  S: '#f5d3b8', // skin
  s: '#e2ae8f', // skin shadow
  C: '#f09c98', // blush
  E: '#3a2216', // eye
  W: '#ffffff', // eye glint
  M: '#b0614f', // mouth
  T: '#26252c', // tee
  t: '#3b3a44', // tee highlight
  P: '#a4a4aa', // grey joggers
  p: '#85858c', // back leg
  B: '#1c1c21', // sneaker
  R: '#d0453a', // glove red
  e: '#f2f2ee', // sneaker sole

  // ? block + coin
  D: '#5a3c17', // block outline
  Q: '#e2a83e', // gold
  q: '#b27623', // gold shade
  Y: '#fbe6a6', // gold highlight
  U: '#8b6a47', // used block
  u: '#634a31', // used block shade

  // ground
  G: '#5f8d52', // grass
  g: '#44703f', // grass shade
  h: '#9cc275', // grass highlight
  X: '#6f5039', // dirt
  x: '#573e2c', // dirt shade
  z: '#8c6a4c', // dirt speck

  // castle bricks
  L: '#9c8e82',
  l: '#6f635a',
  O: '#1a1614',

  // icons
  A: '#e4e0d4',
  a: '#9f9b90',
  c: '#2f6d71',
  F: '#9fe3c6',
  r: '#ee8b7e',
  d: '#8e2a23',
  V: '#5b7f8b',
  v: '#3f5f6a',
  N: '#f4f1e8',
  I: '#3e5f8a',
  i: '#5b80b1',
  w: '#e8e2d2',

  // enemies
  J: '#86c56f', // slime
  j: '#4e9147',
  H: '#d3f2bb',
  m: '#8a6bd6', // bug shell
  n: '#4d3a8a',
  f: '#c3b0f4',
}

const HEAD = [
  '................',
  '.....KKkKKK.....',
  '...KKKKKKKKKK...',
  '..KKKkKKKKKKKK..',
  '.KKKKKKKKKKKKKK.',
  '.KKKKKKKKKKKKKKK',
  '.KKKKKKKSKKKSKK.',
  '.KKKSSKSSSSSSSK.',
  '.KKSSSSSSSSSSSS.',
  '.KsSSSSEWSSEWSS.',
  '.KsSSSSEESSEESS.',
  '..sSSSCSSSSSCSS.',
  '...sSSSSSMMSSS..',
  '....ssSSSSSSs...',
]
const HEAD_BLINK = HEAD.map((row, i) =>
  i === 9 ? '.KsSSSSSSSSSSSS.' : i === 10 ? '.KsSSSSEESSEESS.' : row)

const TORSO = [
  '......TTTTT.....',
  '....tTTTTTTTt...',
  '...tTTTTTTTTTt..',
  '..rRTTTTTTTTTrR.',
  '..RRTTTTTTTTTRR.',
]
const TORSO_SWING_A = [
  '......TTTTT.....',
  '....tTTTTTTTt...',
  '...tTTTTTTTTTt..',
  '.rRsTTTTTTTTTTrR',
  '.RR.TTTTTTTTT.RR',
]
const TORSO_SWING_B = [
  '......TTTTT.....',
  '....tTTTTTTTt...',
  '...tTTTTTTTTTt..',
  '...rRTTTTTTTTrR.',
  '...RRTTTTTTTTRR.',
]
// Uppercut into the block
const TORSO_JUMP = [
  '......TTTTT..rR.',
  '....tTTTTTTTtRR.',
  '...tTTTTTTTTTt..',
  '.rRTTTTTTTTTTs..',
  '.RRTTTTTTTTTTs..',
]

const LEGS_IDLE = [
  '....PPPPPPPPP...',
  '....PPP...PPP...',
  '....PPP...PPP...',
  '....BBB...BBB...',
  '...BBBe...BBBe..',
]
const LEGS_STRIDE_A = [
  '....PPPPPPPPP...',
  '...pPP.....PPP..',
  '..ppp.......PPP.',
  '.BBB.........BBB',
  'BBBe........BBBe',
]
const LEGS_PASS = [
  '.....PPPPPPP....',
  '.....pPPPPPP....',
  '......PPPPP.....',
  '.....BBBBBBB....',
  '....BBBeBBBBe...',
]
const LEGS_STRIDE_B = [
  '....PPPPPPPPP...',
  '...PPP.....ppP..',
  '..PPP.......ppp.',
  '.BBB.........BBB',
  'BBBe........BBBe',
]
const LEGS_JUMP = [
  '....PPPPPPPPP...',
  '....PPP...PPPP..',
  '...PPP.....BBBB.',
  '...BBB.....BBBe.',
  '..BBBe..........',
]

// Jab: front arm fully extended.
const TORSO_PUNCH = [
  '......TTTTT.........',
  '....tTTTTTTTt.......',
  '...tTTTTTTTTTtSSrRR.',
  '..rRTTTTTTTTTsSSRRR.',
  '..RRTTTTTTTTT.......',
]

// Every frame is FRAME_W wide: a 16px body plus room for the punch on the right.
export const FRAME_W = 20
const pad = (rows) => rows.map((r) => r.padEnd(FRAME_W, '.'))

// Frame order matters: it is the column order of the rendered sprite sheet.
export const DAVIE_FRAMES = {
  idle: [...HEAD, ...TORSO, ...LEGS_IDLE],
  blink: [...HEAD_BLINK, ...TORSO, ...LEGS_IDLE],
  walk0: [...HEAD, ...TORSO_SWING_A, ...LEGS_STRIDE_A],
  walk1: [...HEAD, ...TORSO, ...LEGS_PASS],
  walk2: [...HEAD, ...TORSO_SWING_B, ...LEGS_STRIDE_B],
  walk3: [...HEAD, ...TORSO, ...LEGS_PASS],
  jump: [...HEAD, ...TORSO_JUMP, ...LEGS_JUMP],
  punch: [...HEAD, ...TORSO_PUNCH, ...LEGS_STRIDE_A],
}
Object.keys(DAVIE_FRAMES).forEach((k) => (DAVIE_FRAMES[k] = pad(DAVIE_FRAMES[k])))


// Enemies: three frames each (two idle frames, then knocked out). They face left, toward Davie.
export const ENEMIES = {
  slime: [
    [
      '................',
      '................',
      '......jjjj......',
      '....jjJJJJjj....',
      '...jJJHHJJJJj...',
      '..jJJHHJJJJJJj..',
      '..jJJJJJJJJJJj..',
      '.jJJNONJJNONJJj.',
      '.jJJOOOJJOOOJJj.',
      '.jJJJJJJJJJJJJj.',
      '.jJJJJJOOJJJJJj.',
      'jJJJJJJJJJJJJJJj',
      'jjJJJJJJJJJJJJjj',
      '.jjjjjjjjjjjjjj.',
    ],
    [
      '................',
      '................',
      '................',
      '.....jjjjjj.....',
      '...jjJJHHJJjj...',
      '..jJJHHJJJJJJj..',
      '.jJJJJJJJJJJJJj.',
      '.jJJNONJJNONJJj.',
      '.jJJOOOJJOOOJJj.',
      '.jJJJJJJJJJJJJj.',
      'jJJJJJJOOJJJJJJj',
      'jJJJJJJJJJJJJJJj',
      'jjJJJJJJJJJJJJjj',
      '.jjjjjjjjjjjjjj.',
    ],
    [
      '................',
      '................',
      '......jjjj......',
      '....jjJJJJjj....',
      '...jJJHHJJJJj...',
      '..jJJHHJJJJJJj..',
      '..jJJJJJJJJJJj..',
      '.jJJJJJJJJJJJJj.',
      '.jJJOOOJJOOOJJj.',
      '.jJJJJJJJJJJJJj.',
      '.jJJJJOOOOJJJJj.',
      'jJJJJJOOOOJJJJJj',
      'jjJJJJJJJJJJJJjj',
      '.jjjjjjjjjjjjjj.',
    ],
  ],
  bug: [
    [
      '................',
      '...O......O.....',
      '....O....O......',
      '.....nnnnn......',
      '....nmmmmmn.....',
      '...nNOmmNOmn....',
      '...nmmmmmmmn....',
      '..nnnnnnnnnnnn..',
      '.nffmmmnmmmmmmn.',
      '.nfmmmmnmmmmmmn.',
      '.nmmmmmnmmmmmmn.',
      '..nmmmmnmmmmmn..',
      '..O.O..O..O.O...',
      '.O..O..O..O..O..',
    ],
    [
      '................',
      '..O........O....',
      '...O......O.....',
      '.....nnnnn......',
      '....nmmmmmn.....',
      '...nNOmmNOmn....',
      '...nmmmmmmmn....',
      '..nnnnnnnnnnnn..',
      '.nffmmmnmmmmmmn.',
      '.nfmmmmnmmmmmmn.',
      '.nmmmmmnmmmmmmn.',
      '..nmmmmnmmmmmn..',
      '...O.O..O..O.O..',
      '..O..O..O..O..O.',
    ],
    [
      '................',
      '...O......O.....',
      '....O....O......',
      '.....nnnnn......',
      '....nmmmmmn.....',
      '...nOOmmOOmn....',
      '...nmmmmmmmn....',
      '..nnnnnnnnnnnn..',
      '.nffmmmnmmmmmmn.',
      '.nfmmmmnmmmmmmn.',
      '.nmmmmmnmmmmmmn.',
      '..nmmmmnmmmmmn..',
      '..O.O..O..O.O...',
      '.O..O..O..O..O..',
    ],
  ],
  robot: [
    [
      '.......R........',
      '.......a........',
      '...aaaaaaaaaa...',
      '...aAAAAAAAAa...',
      '...aAccccccAa...',
      '...aAFccFccAa...',
      '...aAccccccAa...',
      '...aAAAAAAAAa...',
      '...aaaaaaaaaa...',
      '....aAAAAAAa....',
      '..aaAAaAAaAAaa..',
      '....aAAAAAAa....',
      '....aa....aa....',
      '...aaa....aaa...',
    ],
    [
      '.......Q........',
      '.......a........',
      '...aaaaaaaaaa...',
      '...aAAAAAAAAa...',
      '...aAccccccAa...',
      '...aAcFccFcAa...',
      '...aAccccccAa...',
      '...aAAAAAAAAa...',
      '...aaaaaaaaaa...',
      '....aAAAAAAa....',
      '..aaAAaAAaAAaa..',
      '....aAAAAAAa....',
      '....aa....aa....',
      '...aaa....aaa...',
    ],
    [
      '.......O........',
      '.......a........',
      '...aaaaaaaaaa...',
      '...aAAAAAAAAa...',
      '...aAccccccAa...',
      '...aAOccOccAa...',
      '...aAccccccAa...',
      '...aAAAAAAAAa...',
      '...aaaaaaaaaa...',
      '....aAAAAAAa....',
      '..aaAAaAAaAAaa..',
      '....aAAAAAAa....',
      '....aa....aa....',
      '...aaa....aaa...',
    ],
  ],
  ghost: [
    [
      '.....NNNNN......',
      '...NNNNNNNNN....',
      '..NNNNNNNNNNN...',
      '.NNOONNNOONNNN..',
      '.NNOONNNOONNNN..',
      '.NNNNNNNNNNNNN..',
      '.NNNNOOONNNNNN..',
      '.NNNNOOONNNNNN..',
      '.NNNNNNNNNNNNN..',
      '.wNNNNNNNNNNNw..',
      '.wNNNNNNNNNNNw..',
      '.wwNNwNNNwNNww..',
      '.w.wwww.wwww.w..',
      '................',
    ],
    [
      '................',
      '.....NNNNN......',
      '...NNNNNNNNN....',
      '..NNNNNNNNNNN...',
      '.NNOONNNOONNNN..',
      '.NNOONNNOONNNN..',
      '.NNNNNNNNNNNNN..',
      '.NNNNOOONNNNNN..',
      '.NNNNOOONNNNNN..',
      '.NNNNNNNNNNNNN..',
      '.wNNNNNNNNNNNw..',
      '.wNNwwNNNwwNNw..',
      '..ww.www..www...',
      '................',
    ],
    [
      '.....NNNNN......',
      '...NNNNNNNNN....',
      '..NNNNNNNNNNN...',
      '.NNNNNNNNNNNNN..',
      '.NNOOONNOOONNN..',
      '.NNNNNNNNNNNNN..',
      '.NNNNNOONNNNNN..',
      '.NNNNOOOONNNNN..',
      '.NNNNNNNNNNNNN..',
      '.wNNNNNNNNNNNw..',
      '.wNNNNNNNNNNNw..',
      '.wwNNwNNNwNNww..',
      '.w.wwww.wwww.w..',
      '................',
    ],
  ],
}

export const BURST = [
  '......Y......',
  '......Y......',
  '..Y...Y...Y..',
  '...Y..Q..Y...',
  '....YQQQY....',
  '.....QNQ.....',
  'YYYQQNNNQQYYY',
  '.....QNQ.....',
  '....YQQQY....',
  '...Y..Q..Y...',
  '..Y...Y...Y..',
  '......Y......',
  '......Y......',
]

export const COIN = [
  '...DDDD...',
  '..DYYYQD..',
  '.DYYQQQqD.',
  '.DYQYYQqD.',
  '.DYQYQQqD.',
  '.DYQYQQqD.',
  '.DYQYQQqD.',
  '.DYQYQQqD.',
  '.DYQYQQqD.',
  '.DYQqqQqD.',
  '.DYQQQQqD.',
  '..DQQQqD..',
  '...DDDD...',
]

export const GRASS = [
  'hhGhhhGhhhhGhhhG',
  'GGGGhGGGGGGGhGGG',
  'GgGGGGgGGgGGGGgG',
  'gxgGgxgggxgGgxgg',
  'xXXxXXXXxXXXXxXX',
  'XXXXXzXXXXXXXXXX',
  'XXxXXXXXXXzXXxXX',
  'XXXXXXXxXXXXXXXX',
]

export const DIRT = [
  'XzXXXXXXXXXXXzXX',
  'XXXXxXXXXzXXXXXX',
  'XXXXXXXXXXXXxXXX',
  'xXXzXXXxXXXXXXXX',
  'XXXXXXXXXXXzXXXX',
  'XXxXXXXXXXXXXXxX',
  'XXXXXzXXXxXXXXXX',
  'XXXXXXXXXXXXXXXX',
]

// Brick castle, generated so the mortar pattern stays regular.
function castle() {
  const W = 30, H = 28
  const rows = []
  for (let y = 0; y < H; y++) {
    let row = ''
    for (let x = 0; x < W; x++) {
      const upper = y < 12
      const inBody = upper ? x >= 8 && x < 22 : true
      let ch = '.'
      if (inBody) {
        // crenellations
        const crenelRow = upper ? y < 3 : y >= 12 && y < 15
        const crenelX = upper ? x - 8 : x
        if (crenelRow && Math.floor(crenelX / 2) % 2 === 1) ch = '.'
        else {
          const by = upper ? y : y - 12
          const mortarRow = by % 3 === 2
          const offset = Math.floor(by / 3) % 2 ? 2 : 0
          ch = mortarRow || (x + offset) % 4 === 3 ? 'l' : 'L'
        }
        // windows
        if (upper && y >= 5 && y < 9 && (x === 12 || x === 13 || x === 16 || x === 17)) ch = 'O'
        // arched door
        const dx = x - 14.5
        if (y >= 19 && Math.abs(dx) < 3.5 && !(y === 19 && Math.abs(dx) > 2)) ch = 'O'
      }
      row += ch
    }
    rows.push(row)
  }
  return rows
}
export const CASTLE = castle()

export const FLAG = [
  'RRRRRRRRRR....',
  'RRRRRRRRRRRR..',
  'RRRNNNNRRRRRRR',
  'RRRNRRRNRRRRRR',
  'RRRNRRRNRRRRRR',
  'RRRNNNNRRRRR..',
  'RRRRRRRRRR....',
]

export const ICONS = {
  invest: COIN,
  wand: [
    '.........Y..',
    '........YQY.',
    '..N....YQQQY',
    '........YQY.',
    '........Y.Y.',
    '.......A....',
    '......A.....',
    '.....A....N.',
    '....A.......',
    '...A........',
    '..A.........',
    '.A..........',
  ],
  trophy: [
    '.QQQQQQQQQQ.',
    'QQYYQQQQQqQQ',
    'Q.QYQQQQqQ.Q',
    'Q.QYQQQQqQ.Q',
    '.QQYQQQQqQQ.',
    '...QYQQqQ...',
    '....QQqQ....',
    '.....Qq.....',
    '.....Qq.....',
    '...DDDDDD...',
    '...DqqqqD...',
    '..DDDDDDDD..',
  ],
  builder: [
    '............',
    '.aaaaaaaaaa.',
    '.acccccccca.',
    '.acFFccccca.',
    '.acccFFFcca.',
    '.acFFFcccca.',
    '.acccccccca.',
    '.aaaaaaaaaa.',
    'AAAAAAAAAAAA',
    'aaaaaaaaaaaa',
  ],
  boxing: [
    '...RRRRR....',
    '..RrrRRRR...',
    '.RrRRRRRRR..',
    '.RrRRRRRRRR.',
    'RRrRRRRRRRR.',
    'RRRRRRRRRRd.',
    'RdRRRRRRRRd.',
    '.RRRRRRRRdd.',
    '..RRRRRRRd..',
    '...ddddddd..',
    '...AAAAAAA..',
    '...aaaaaaa..',
  ],
  hiking: [
    '.....N......',
    '....NNN.....',
    '...NNVNN....',
    '..VVVVVVV.v.',
    '..VVVVVVVvvv',
    '.VVVVVVVVvvv',
    'VVVVVVVVVVvv',
    'GGGGGGGGGGGG',
    'gggggggggggg',
  ],
  reading: [
    '..IIIIIIIII.',
    '.IiiiiiiiiI.',
    '.IiwwwwwiiI.',
    '.IiiiiiiiiI.',
    '.IiwwwwiiiI.',
    '.IiiiiiiiiI.',
    '.IiiiiiiiiI.',
    '.IIIIIIIIII.',
    '.wwwwwwwwww.',
    '..IIIIIIIII.',
  ],
  nota: [
    '.AAAAA......',
    '.AaaaA......',
    '.AAAAA......',
    '.AaaaAOOO...',
    '.AAAAONNNO..',
    '.AaaaONNNO..',
    '.AAAAONNNO..',
    '.AAAAAOOO...',
    '.........O..',
    '..........O.',
    '...........O',
  ],
  gov: [
    '.....AA.....',
    '....AAAA....',
    '..AAAAAAAA..',
    '.AAAAAAAAAA.',
    '..a.a..a.a..',
    '..A.A..A.A..',
    '..A.A..A.A..',
    '..A.A..A.A..',
    '.AAAAAAAAAA.',
    'aaaaaaaaaaaa',
  ],
  comics: [
    '..OOOOOOOO..',
    '.ONNNNNNNNO.',
    'ONNNOONNONNO',
    'ONNONNONONNO',
    'ONNNNONNONNO',
    'ONNNONNNNNNO',
    'ONNNNNNNONNO',
    '.ONNONNNNNO.',
    '..OOONOOOO..',
    '...ONO......',
    '...OO.......',
  ],
}
